<mat-dialog-content class="mat-typography">
  <p [innerText]="msg">  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button  mat-raised-button color="primary" [mat-dialog-close]="true" (click)="doRegister()"  cdkFocusInitial>OK</button>
</mat-dialog-actions>
